export const PAGE = {
  TOP: {
    PATH: '/',
    NAME: 'TOP',
    TEXT: 'トップ',
    DESC: '株式会社サプライムは、自由な発想で未来と新たな価値を創造し、社会に貢献するIT企業です。IoT対応設計、システム効率化、車載・製造業向け組込みソフト開発を手掛けています。'
  },
  SERVICE: {
    PATH: '/service',
    NAME: 'SERVICE',
    TEXT: 'サービス',
    DESC: '自由な発想で新たな領域に踏み込み、ITを通して未来と新たな価値を創造し、社会に貢献をしていきます。'
  },
  SYSTEM: {
    PATH: '/service/system',
    NAME: 'SYSTEM',
    TEXT: 'システム開発',
    DESC: '高品質かつ信頼性の高いハードウェアソリューションを提供します。'
  },
  SOFTWARE: {
    PATH: '/service/software',
    NAME: 'SOFTWARE',
    TEXT: 'ソフトウェア開発',
    DESC: '計測機器との連携を含む設計から開発まで、最適なソリューションを提供します。'
  },
  NEWS: {
    PATH: '/news',
    NAME: 'NEWS',
    TEXT: '新着情報',
    DESC: '株式会社サプライムの新着情報をご覧いただけます。'
  },
  NEWS_DETAIL: {
    PATH: '/news/:id',
    NAME: 'NEWS DETAIL',
    TEXT: 'ニュース詳細',
    DESC: '株式会社サプライムの新着情報をご覧いただけます。'
  },
  RECRUIT: {
    PATH: '/recruit',
    NAME: 'RECRUIT',
    TEXT: '採用情報',
    DESC: '様々な業界や企業の課題を一緒に解決できる仲間を募集しています。'
  },
  COMPANY: {
    PATH: '/company',
    NAME: 'COMPANY',
    TEXT: '会社紹介',
    DESC: '株式会社サプライムの企業情報ページです。'
  },
  CONTACT: {
    PATH: '/contact',
    NAME: 'CONTACT',
    TEXT: 'お問い合わせ',
    DESC: 'サービスに関する質問受付や採用エントリーを受け付けています。'
  },
  SECURITY: {
    PATH: '/security',
    NAME: 'SECURITY',
    TEXT: '情報セキュリティ基本方針',
    DESC: '株式会社サプライムは、情報セキュリティに取り組んでまいります。'
  },
  ERROR: {
    PATH: '*',
    NAME: '404',
    TEXT: 'NOT FOUND',
    DESC: 'お探しのページが見つかりませんでした。'
  }
} as const;
export type Path = typeof PAGE[keyof typeof PAGE];